

export default defineNuxtPlugin(nuxtApp => {  
  
  // const { error:errorToast, success: successToast, add: addToast, remove: removeToast } = useToast();

  // var toast = {    
  //   add: addToast,
  //   error: errorToast,
  //   success: successToast,
  //   remove: removeToast,
    
  // } 

  // return {
  //   provide: {
  //     toast: toast,
  //   },
  // };

})